import React from "react";
import { Message as ThemeMessage, ThemeUIStyleObject } from "theme-ui";

type Props = {
  children: React.ReactNode;
  sx?: ThemeUIStyleObject | undefined;
  variant: string;
};

export const Message: React.FC<Props> = ({ children, sx, variant }) => {
  return (
    <ThemeMessage
      variant={variant}
      sx={{
        ...sx,
        position: "relative",
        "::after": {
          content: '""',
          position: "absolute",
          height: "20px",
          width: "20px",
          backgroundColor: "var(--theme-ui-colors-warningScale-1)",
          top: "-10px",
          left: "50%",
          transform: "rotate(45deg)",
        },
      }}
    >
      {children}
    </ThemeMessage>
  );
};
